import useNotificationHandler from "hooks/useNotificationHandler";
import { MUTATION_KEYS } from "library/shared";
import { Attachment } from "library/types";
import { useMutation, useQueryClient } from "react-query";
import api from "service/api";
import { useInvalidateDependentEnrollment } from "./useGetDependentEnrollment";
import { useInvalidateEmployeeEnrollment } from "./useGetEmployeeEnrollment";

type Params = {
  countryCode: number | string;
  clientInternalNumberGOS: number | string;
  benefitImplementationTag: number | string;
  benefitPackageTag: number | string;
  employeeEnrollmentTag: number | string;
  employeeLoginEmailAddress: string;

  attachmentName: string;
  payload: Attachment;
};
const updateAttachment = async ({
  countryCode,
  clientInternalNumberGOS,
  benefitImplementationTag,
  benefitPackageTag,
  employeeEnrollmentTag,
  employeeLoginEmailAddress,
  attachmentName,

  payload,
}: Params) => {
  const response = await api.patch(
    `/employeeenrollment/attachment/${countryCode}/${clientInternalNumberGOS}/${benefitImplementationTag}/${benefitPackageTag}/${employeeLoginEmailAddress}/${employeeEnrollmentTag}/${attachmentName}`,
    payload
  );

  return response.data as Attachment;
};
export function useUpdateEnrollmentAttachment(
  refetch = true,
  isDependent = false
) {
  const { handleAddAxiosErrorNotification } = useNotificationHandler();
  const invalidateEmployeeEnrollment = useInvalidateEmployeeEnrollment();
  const invalidateDependentEnrollment = useInvalidateDependentEnrollment();
  return useMutation(updateAttachment, {
    mutationKey: MUTATION_KEYS.updateEnrollmentAttachment,
    onSuccess: () => {
      if (refetch) {
        if (isDependent) {
          invalidateDependentEnrollment();
        } else {
          invalidateEmployeeEnrollment();
        }
      }
    },
    onError: (error) => {
      // handle error
      handleAddAxiosErrorNotification(error);
    },
  });
}
